<div class="bigdiv">
  <div class="div">
    <div>
      <h1 class="h1">User Manager</h1>
    </div>
    <div style="display: flex" *ngIf="userData.length > 0">
      <div>
        <button
          style="
            width: 350px;
            height: 45px;
            border-radius: 8px;
            background: #00498f;
            color: #ffff;
            display: flex;
            align-items: center;
            justify-content: left;
          "
          mat-raised-button
          (click)="openDialog()"
        >
          <img [src]="Search" alt="search" />&nbsp;<span>
            Search & Add Users</span
          >
        </button>
      </div>
    </div>
    <div style="display: flex" *ngIf="userData.length > 0">
      <p class="Showing" style="margin-top: 13px; font-size: 13px; font-weight: 500;">
        Showing {{ calculateMin() }} to {{ calculateMax() }} of
        {{ calculateTotal() }}
      </p>
    </div>
  </div>
  <div class="main">  
    <div
      *ngIf="showSpinner"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 500px;
      "
    >
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <!-- Placeholder image displayed when no data is available -->
    <div
      style="display: flex; align-items: center; justify-content: center"
      *ngIf="!showSpinner && userData.length === 0"
    >
      <img
        [src]="noData"
        alt="No Data Available"
        style="width: 515px; height: 515px"
      />
    </div>
    <section class="example-container mat-elevation-z" tabindex="0">
      <table
        mat-table
        [dataSource]="userData" 
        *ngIf="userData.length > 0 && !showSpinner"
        class="mat-elevation-z8"
        matSort
        (matSortChange)="onSortChange($event)"
      >
        <!-- Table headers -->
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);">
            S.No
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            style="text-align: center; font-size: 13px; font-weight: 600;"
          >
            {{ (pageEvent.page - 1) * 10 + i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="eventId">
          <th
            mat-header-cell
            *matHeaderCellDef
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            Login Name
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.account_name }}
          </td>
        </ng-container>
        <!-- Description: This table presents user data with sorting functionality. -->
        <!-- Add your table headers, rows, and cells here -->
        <ng-container matColumnDef="user">
          <th
            mat-header-cell
            *matHeaderCellDef
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            Login Access
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.login_access }}
          </td>
        </ng-container>
        <!-- Description: This table presents user data with sorting functionality. -->
        <!-- Add your table headers, rows, and cells here -->
        <ng-container matColumnDef="activity">
          <th
            mat-header-cell
            *matHeaderCellDef
            sortActionDescription="Sort by number"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            Is Admin
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 13px; font-weight: 600;"
          >
            {{ element.login_sa }}
          </td>
        </ng-container>
        <!-- Description: This table presents user data with sorting functionality. -->
        <!-- Add your table headers, rows, and cells here -->
        <ng-container matColumnDef="event">
          <th mat-header-cell *matHeaderCellDef style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);">Edit</th>
          <td mat-cell *matCellDef="let element" style="font-size: 13px; font-weight: 600;">
            {{ element.event }}
            <img
              [src]="Edit"
              style="cursor: pointer"
              alt="Edit"
              (click)="openEditDialog(element)"
            />
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <!-- End of table -->
        <!-- Add more ng-container elements for other columns as needed -->
      </table>
    </section>
    <div class="pagination-column" *ngIf="!showSpinner">
      <div *ngFor="let page of getCustomPageRange()">
        <span class="page">
          <div>
            <button
              (click)="onPageClick(page)"
              class="pagination"
              [ngClass]="{ active: isCurrentPage(page) }"
            >
              {{ page }}
            </button>
          </div>
        </span>
        <ng-container
          *ngIf="page !== getCustomPageRange()[getCustomPageRange().length - 1]"
        >
          <ng-template #ellipsis>
            <span>... </span>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
